export default{
    getDdsUserRole(state){
        return state.ddsUserRole;
    },

    getDiligenceDetails(state){
        return state.diligenceDetails;
    },

    getDetailWarnings(state){
        return state?.diligenceData?.riskWarnings || [];
    },

    getDdsAdditionalInformationData(state){
        return state.ddsAdditionalInformationData;
    },

    ddsAdditionalInformationByDiligenceId(state){
        return state.ddsAdditionalInformationByDiligenceId;
    },
    
    ddsAdditionalInformationByDiligenceIdLatest(state){
        const list = state.ddsAdditionalInformationByDiligenceId || [];
        if (!Array.isArray(list) || list.length === 0) return undefined;
        // Sort by numeric id DESC to get the latest entry
        const sorted = [...list].sort((a, b) => (parseInt(b?.id || 0, 10)) - (parseInt(a?.id || 0, 10)));
        return sorted[0];
    }
}